export default class Epar {
	id: string;

	category: string;

	medicineName: string;

	previousMedicineName: string | null;

	therapeuticAreas: string[];

	internationalNonProprietaryNameOrCommonName: string;

	activeSubstance: string;

	productNumber: string;

	patientSafety: boolean;

	authorisationStatus: string;

	atcCode: string;

	additionalMonitoring: boolean;

	generic: boolean;

	biosimilar: boolean;

	conditionalApproval: boolean;

	exceptionalCircumstances: boolean;

	acceleratedAssessment: boolean;

	orphanMedicine: boolean;

	marketingAuthorisationDate: Date | null;

	dateOfRefusalOfMarketingAuthorisation: Date | null;

	marketingAuthorisationHolderOrCompanyName: string;

	humanPharmacotherapeuticGroup: string;

	dateOfOpinion: Date | null;

	decisionDate: Date | null;

	revisionNumber: number;

	conditionOrIndication: string;

	firstPublished: Date;

	revisionDate: Date | null;

	url: string;

	constructor(
		id: string,
		category: string,
		medicineName: string,
		previousMedicineName: string | null,
		therapeuticAreas: string[],
		internationalNonProprietaryNameOrCommonName: string,
		activeSubstance: string,
		productNumber: string,
		patientSafety: boolean,
		authorisationStatus: string,
		atcCode: string,
		additionalMonitoring: boolean,
		generic: boolean,
		biosimilar: boolean,
		conditionalApproval: boolean,
		exceptionalCircumstances: boolean,
		acceleratedAssessment: boolean,
		orphanMedicine: boolean,
		marketingAuthorisationDate: Date | null,
		dateOfRefusalOfMarketingAuthorisation: Date | null,
		marketingAuthorisationHolderOrCompanyName: string,
		humanPharmacotherapeuticGroup: string,
		dateOfOpinion: Date | null,
		decisionDate: Date | null,
		revisionNumber: number,
		conditionOrIndication: string,
		firstPublished: Date,
		revisionDate: Date | null,
		url: string
	) {
		this.id = id;
		this.category = category;
		this.medicineName = medicineName;
		this.previousMedicineName = previousMedicineName;
		this.therapeuticAreas = therapeuticAreas;
		this.internationalNonProprietaryNameOrCommonName = internationalNonProprietaryNameOrCommonName;
		this.activeSubstance = activeSubstance;
		this.productNumber = productNumber;
		this.patientSafety = patientSafety;
		this.authorisationStatus = authorisationStatus;
		this.atcCode = atcCode;
		this.additionalMonitoring = additionalMonitoring;
		this.generic = generic;
		this.biosimilar = biosimilar;
		this.conditionalApproval = conditionalApproval;
		this.exceptionalCircumstances = exceptionalCircumstances;
		this.acceleratedAssessment = acceleratedAssessment;
		this.orphanMedicine = orphanMedicine;
		this.marketingAuthorisationDate = marketingAuthorisationDate;
		this.dateOfRefusalOfMarketingAuthorisation = dateOfRefusalOfMarketingAuthorisation;
		this.marketingAuthorisationHolderOrCompanyName = marketingAuthorisationHolderOrCompanyName;
		this.humanPharmacotherapeuticGroup = humanPharmacotherapeuticGroup;
		this.dateOfOpinion = dateOfOpinion;
		this.decisionDate = decisionDate;
		this.revisionNumber = revisionNumber;
		this.conditionOrIndication = conditionOrIndication;
		this.firstPublished = firstPublished;
		this.revisionDate = revisionDate;
		this.url = url;
	}
}
